import React, { Component } from 'react';
import { Col, Row, Container, Card } from '../../legacy/hui/src/styled';
import styled from 'styled-components';
import { storeList } from '../data/store-list';
import { TitleBar } from './TitleBar';
import { ButtonSubmit } from './Bunnings/Buttons';

export const ItemTitle = styled.div`
  font-size: 20px;
  color: #0d5257;
  line-height: 26px;
  margin-bottom: 10px;
`;

export const ItemText = styled.div`
  color: #555659;
  font-size: 14px;
  line-height: 26px;
`;

export default class StoreList extends Component {
  componentDidMount() {
    window.scrollTo(0, 0);
  }
  render() {
    return (
      <React.Fragment>
        <TitleBar pageTitle={'Participating Stores'} />
        <Container mb={1.2}>
          <Row>
            {storeList &&
              storeList.map(dataItem => {
                return (
                  <Col xs={12} md={6} key={dataItem.storeName}>
                    <Card snow>
                      <Row>
                        <Col xs={12} md={7.5}>
                          <ItemTitle>{dataItem.storeName}</ItemTitle>
                          <ItemText>{dataItem.phone}</ItemText>
                          <ItemText>{dataItem.address}</ItemText>
                          <ItemText>{dataItem.suburb}</ItemText>
                        </Col>
                        <Col xs={8} md={4.5}>
                          <ButtonSubmit
                            block
                            tag="a"
                            href={dataItem.direction}
                            style={{ fontSize: 12, borderRadius: '100px' }}
                          >
                            Get Directions
                          </ButtonSubmit>
                        </Col>
                      </Row>
                    </Card>
                  </Col>
                );
              })}
          </Row>
        </Container>
      </React.Fragment>
    );
  }
}
